import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const SunatCommunicationBatchListPage = lazy(() =>
  import('./pages/SunatCommunicationBatchListPage').then((module) => ({
    default: module.SunatCommunicationBatchListPage,
  })),
);

const SunatCommunicationBatchesPage = lazy(() =>
  import('./pages/SunatCommunicationBatchesPage').then((module) => ({
    default: module.SunatCommunicationBatchesPage,
  })),
);

const SunatCommunicationBatchDetailPage = lazy(() =>
  import('./pages/SunatCommunicationBatchDetailPage').then((module) => ({
    default: module.SunatCommunicationBatchDetailPage,
  })),
);

export const sunatCommunicationBatchesRoutes: RouteObject[] = [
  {
    path: 'comunicaciones-sunat',
    element: createElement(ProtectedRoute, { view: 'sunatCommunicationBatches' }),
    children: [
      { index: true, element: createElement(SunatCommunicationBatchListPage) },
      { path: 'nuevo', element: createElement(SunatCommunicationBatchesPage) },
      {
        path: ':id',
        element: createElement(ProtectedRoute, { view: 'sunatCommunicationBatchDetail' }),
        children: [{ index: true, element: createElement(SunatCommunicationBatchDetailPage) }],
      },
    ],
  },
];
